
const limelightAccordions = function limelightAccordions() {
  window.accordionWrappers = [];
  const { Limelight, accordionWrappers } = window;

  const updateAccordions = function updateAccordions() {
    const startingIndex = accordionWrappers.length;
    const accordions = document.querySelectorAll('[data-trigger="accordion"]');

    accordions.forEach((element, index) => {
      const i = startingIndex + index;

      if (!element.classList.contains('limelight-initialised')) {
        let visible = false;
        if (element.classList.contains('active')) {
          visible = true;
        }
        window.accordionWrappers[i] = new Limelight('' + element.dataset.target, {
          visible,
          slide: true,
          slideSpeed: 250,
          triggerClass: 'active',
          beforeShowCallback: function beforeShowCallback(element, elements) {
            window.accordionWrappers.forEach((accordion) => {
              Limelight.elements[accordion.target].hide();
            });
          }
        });
        element.classList.add('limelight-initialised');
      }
    });
  };

  document.addEventListener('accordions:update', updateAccordions);
  updateAccordions();
};

exports.default = limelightAccordions;
